@if (addressValue) {
  <div>
    <dl class="p-2">
      <div class="d-flex align-items-center gap-2">
        <div class="flex-grow-1">
          <dt>Address</dt>
          <dd>
            {{ addressValue }}
          </dd>
        </div>
        <div class="d-flex gap-2">
          <span (click)="onSearchAnotherAddress()" class="edit-button"> </span>
          @if (
            !["subscriberAddress", "addCheckpoint"].includes(showLookupFrom) &&
            addressForm?.value?.latitude
          ) {
            <span
              (click)="editSelectedAddress = false; showMap = !showMap"
              class="me-3"
            >
              @if (showMap) {
                <span>
                  <i
                    title="Toggle Map View"
                    class="fa-solid fa-map-location-dot md-font-size text-primary"
                  ></i>
                </span>
              } @else {
                <span>
                  <i
                    title="Toggle Map View"
                    class="fa-solid fa-map-location-dot md-font-size text-secondary"
                  ></i>
                </span>
              }
            </span>
          }
          <span
            (click)="
              showMap = false; editSelectedAddress = !editSelectedAddress
            "
            class="me-3"
          >
            @if (editSelectedAddress) {
              <span>
                <i
                  class="fa-solid fa-pen-to-square md-font-size text-primary"
                ></i>
              </span>
            } @else {
              <span>
                <i
                  class="fa-solid fa-pen-to-square md-font-size text-secondary"
                ></i>
              </span>
            }
          </span>
        </div>
      </div>
    </dl>
  </div>
}
@if (!addressValue && addressFormInValidCheck()) {
  <div>
    <gtapp-auto-complete
      [data]="addrLookupData"
      [placeHolder]="placeholder"
      searchKeyword="full_address"
      [itemTemplate]="addressTemplate"
      [addInitialKey]="!largeView"
      inputId="addressLookup"
      (inputChanged)="onAddressSearch($event)"
      [enableCloseOption]="true"
      (selected)="addressSelected($event)"
      (fieldCleared)="shiftFocus()"
    >
    </gtapp-auto-complete>
    <ng-template #addressTemplate let-item>
      @if (item?.key === 0) {
        <div>My Current Location</div>
      } @else {
        @if (item?.feature_type === "address") {
          <!-- show only full address-->
          <ng-container>
            <div class="small py-1 fw-semibold">
              {{
                item?.properties?.full_address ??
                  item?.full_address ??
                  item?.properties?.place_formatted | uppercase
              }}
            </div>
          </ng-container>
          <!-- need to show both address and name here-->
        } @else {
          @if (item?.placePrediction?.placeId) {
            <!--google places search results-->
            @if (item?.placePrediction?.structuredFormat?.mainText?.text) {
              <div class="fw-semibold">
                {{
                  item?.placePrediction?.structuredFormat?.mainText?.text
                    | uppercase
                }}
              </div>
            }
            <div
              class="small py-1"
              [ngClass]="
                item?.placePrediction?.structuredFormat?.mainText?.text
                  ? ''
                  : 'fw-semibold'
              "
            >
              {{
                item?.placePrediction?.structuredFormat?.secondaryText?.text
                  | uppercase
              }}
            </div>
          } @else {
            <ng-container>
              @if (item?.name || item?.properties?.name) {
                <div class="fw-semibold">
                  {{ item?.name ?? item?.properties?.name | uppercase }}
                </div>
              }
              <div
                class="small py-1"
                [ngClass]="
                  item?.name || item?.properties?.name ? '' : 'fw-semibold'
                "
              >
                {{
                  item?.properties?.full_address ??
                    item?.full_address ??
                    item?.properties?.place_formatted | uppercase
                }}
              </div>
            </ng-container>
          }
        }
      }
    </ng-template>
  </div>
}
@if (editSelectedAddress && !showMap) {
  <form
    [formGroup]="addressForm"
    (focusout)="onFormBlur($event)"
    #addressFormTemplate
  >
    @if (
      addressForm.controls["address2"].invalid ||
      addressForm.controls["city_name"].invalid ||
      addressForm.controls["state_code"].invalid ||
      addressForm.controls["state_name"].invalid
    ) {
      <div class="alert alert-danger mt-2" role="alert">
        Unable to get exact address, please fill in missing information
      </div>
    }
    <div class="row g-3 my-1">
      <div class="form-floating">
        <input
          type="text"
          class="form-control"
          id="address3"
          formControlName="address3"
          maxlength="100"
          autocomplete="off"
          placeholder="Unit"
        />
        <label for="address3">Address Prefix (Suite/Lot/Unit)</label>
      </div>
      <div class="form-floating">
        <input
          type="text"
          class="form-control"
          id="address1"
          formControlName="address1"
          maxlength="30"
          placeholder="Street Number"
        />
        <label for="address1">Street Number</label>
      </div>
      <div class="form-floating">
        <input
          type="text"
          class="form-control"
          id="address2"
          formControlName="address2"
          maxlength="100"
          autocomplete="off"
          placeholder="Street"
          required
          [class.is-invalid]="addressForm.controls['address2'].invalid"
        />
        <label for="address2">Street Name</label>
      </div>
      <div class="form-floating">
        <input
          type="text"
          class="form-control text-uppercase"
          id="city_name"
          formControlName="city_name"
          maxlength="100"
          autocomplete="off"
          placeholder="City"
          [class.is-invalid]="addressForm.controls['city_name'].invalid"
          required
          (input)="forceUppercaseConditionally($event)"
        />
        <label for="city_name">Suburb</label>
      </div>

      <div class="form-floating">
        <input
          type="tel"
          inputmode="numeric"
          class="form-control"
          id="postcode"
          formControlName="postcode"
          maxlength="30"
          autocomplete="off"
          placeholder="Post Code"
        />
        <label for="postcode">Post Code</label>
      </div>
      <div class="form-floating">
        <input
          type="text"
          class="form-control"
          id="state_name"
          formControlName="state_name"
          maxlength="100"
          autocomplete="off"
          required
          placeholder="State"
          (input)="onStateInput()"
          [class.is-invalid]="addressForm.controls['state_name'].invalid"
        />
        <label for="state_name">State</label>
      </div>
      <div class="form-floating">
        <input
          type="text"
          class="form-control"
          id="country_name"
          formControlName="country_name"
          maxlength="100"
          autocomplete="off"
          required
          placeholder="State"
          (input)="forceUppercaseConditionally($event, 'country_name')"
          [class.is-invalid]="addressForm.controls['country_name'].invalid"
        />
        <label for="country_name">Country</label>
      </div>
    </div>
  </form>
}
@if (showMap) {
  <gtapp-map-leaflet
    [latLon]="{
      lat: addressForm?.value?.latitude,
      lon: addressForm?.value?.longitude,
    }"
    [mapId]="addressMapId"
    [cursorDraggable]="true"
    (emitData)="emitData($event)"
  ></gtapp-map-leaflet>
  <div class="text-center small">
    <em> Drag the marker to set coordinates </em>
  </div>
}
